module.exports = __webpack_public_path__ + "static/TT-Testfit_Floor28-6b4f8f75190d9ce2bf0356bc1a537cf6.jpg";